(() => {
  const start = () => {
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-bw-open-details]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.open = true;
      target.scrollIntoView({ block: 'start', behavior: 'auto' });
      target.querySelector('summary')?.focus({ preventScroll: true });
    });
    const section = document.getElementById('bw-community-reviews');
    if (!section) return;
    const slot = section.querySelector('[data-bw-review-slot]');
    let queued = false;
    const arrange = () => {
      queued = false;
      const widget = document.querySelector('.fera-allReviews-widget');
      if (!widget || !widget.querySelector('.fera-review')) return;
      if (widget.parentElement !== slot) slot.appendChild(widget);
      // Keep one H1 on the homepage: demote the review app's hidden heading.
      widget.querySelectorAll('h1').forEach(h => {
        const d = document.createElement('div');
        [...h.attributes].forEach(a => d.setAttribute(a.name, a.value));
        d.innerHTML = h.innerHTML;
        h.replaceWith(d);
      });
      section.hidden = false;
      if (!section.querySelector('.bw-reviews-toggle')) {
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bw-reviews-toggle';
        toggle.textContent = section.dataset.viewAll;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', widget.id);
        toggle.addEventListener('click', () => {
          const expanded = section.classList.toggle('bw-community--expanded');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? section.dataset.viewLess : section.dataset.viewAll;
          if (!expanded) section.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
        section.appendChild(toggle);
      }
      section.querySelector('.bw-reviews-toggle').hidden = widget.querySelectorAll('.fera-review').length <= 3;
    };
    const observer = new MutationObserver(() => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(arrange);
      }
    });
    observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    arrange();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();